"use client"

import styled from "@emotion/styled"
import { Box, Button } from "@mui/material"
import { useState } from "react"
import { useInView } from "react-intersection-observer"
import {
  mediaQueries,
  Mobile,
  sizes,
  useInViewConfig,
  useIsDesktop,
  useTransitionUpStyles,
} from "ui"
import PeopleItem from "./PeopleItem"
import { Person } from "./SelectPeoplePopup"

const StyledPeopleGrid = styled(Box)`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  row-gap: 48px;
  width: 100%;
  justify-content: center;

  ${mediaQueries.desktopM} {
    grid-template-columns: repeat(4, 1fr);
    justify-content: center;
    row-gap: 24px;
    column-gap: 24px;
  }
  ${mediaQueries.desktopXl} {
    display: flex;
    flex-wrap: wrap;
    > * {
      width: 292px;
    }
    > *:first-of-type {
      width: 300px;
    }
  }
`

const StyledContainer = styled(Box)`
  width: 100%;
  padding-bottom: ${sizes.baseOcto};
`
const StyledButton = styled(Button)`
  margin: 0 auto;
  margin-top: ${sizes.baseQuadric};
  padding: 10px 18px 10px 14px;
`

interface PeopleListProps {
  people: Person[]
  onPersonClick: (person: Person) => void
}

const CARDS_DISPLAY_NUMBER = 8

const PeopleList = ({ people, onPersonClick }: PeopleListProps) => {
  const { ref, inView } = useInView(useInViewConfig)
  const transitionStyles = useTransitionUpStyles(inView)
  const [displayCount, setDisplayCount] = useState(CARDS_DISPLAY_NUMBER)
  const isDesktop = useIsDesktop()

  const displayedPeople = isDesktop ? people : people.slice(0, displayCount)
  const hasMoreToLoad = displayCount < people.length

  const handleLoadMore = () => {
    setDisplayCount((prevCount) => prevCount + CARDS_DISPLAY_NUMBER)
  }

  return (
    <StyledContainer>
      <StyledPeopleGrid ref={ref} style={transitionStyles}>
        {displayedPeople.map((item, index) => {
          return (
            <PeopleItem
              key={item.fullName}
              person={item}
              onClick={() => onPersonClick(item)}
            />
          )
        })}
      </StyledPeopleGrid>
      <Mobile>
        {hasMoreToLoad && (
          <StyledButton onClick={handleLoadMore}>טען עוד</StyledButton>
        )}
      </Mobile>
    </StyledContainer>
  )
}

export default PeopleList
